
import DatatableTables from 'pages/Tables/DatatableTables'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { Col, Row, Button, Input } from 'reactstrap'
import { getCatalogItems } from 'store/catalogItems/actions';
import CatalogueTable from './CatalogueTable';
import ConfirmationModal from 'components/Modals/ConfirmationModal';
import Breadcrumb from 'components/Common/Breadcrumb2';
import { getSolutions } from 'store/actions';

const Orders = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();
    const [selectedSolution,setSelectedSolution] = useState();
    const catalogItems = useSelector((state) => state.Catalog.catalogItems);
    const solutions = useSelector(state => state?.Solution.solutions);
    const loading = useSelector((state) => state.Catalog.loading);
   
    const error = useSelector((state) => state.Catalog.error);

    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));

    // Dispatch action to fetch catalog items when component mounts
    useEffect(() => {
        if (loading) return;
        dispatch(getSolutions())
    }, [dispatch]);

    useEffect(()=>{
        dispatch(getCatalogItems(selectedSolution)); 
    },[selectedSolution])

    return (
        <>
            <div className='page-content container-fluid'>
                <div className="d-flex justify-content-between align-items-center mx-3">
                    <Breadcrumb title="Catalogues" breadcrumbItems={[{ title: "Dashboard", link: `/dashboard` }, { title: "Catalogues", link: '#' }]} />
                    {permissions2?.map(item => item?.permissionName)?.includes("Add Catalogues") && <Button className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center' onClick={() => navigate('/createCatalogue')}>
                        <i className='ti-plus'></i> Add New
                    </Button>}
                </div>

                <CatalogueTable loading={loading} List={catalogItems?.Data} solutions={solutions}  selectedSolution={selectedSolution}
            setSelectedSolution={setSelectedSolution}/>
            </div>
        </>
    )
}

export default Orders;
